import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { googleAPI } from '../services/api';

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('connecting');
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');

    if (code) {
      completeConnection(code);
    } else {
      setStatus('error');
      setError('No authorization code received');
    }
  }, [searchParams]);

  const completeConnection = async (code) => {
    try {
      await googleAPI.connect(code);
      setStatus('success');
      setTimeout(() => {
        navigate('/quotes/new');
      }, 2000);
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.message || 'Error connecting to Google');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {status === 'connecting' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-900">Conectando con Google...</h2>
            <p className="text-gray-600 mt-2">Por favor espere</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Conectado exitosamente</h2>
            <p className="text-gray-600 mt-2">Redirigiendo...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900">Error de conexion</h2>
            <p className="text-red-600 mt-2">{error}</p>
            <button
              onClick={() => navigate('/quotes/new')}
              className="mt-4 btn btn-primary"
            >
              Volver
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleCallback;
